import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
} from 'react-bootstrap';
import countries from 'country-calling-code';
var UsaStates = require('usa-states').UsaStates;
import actions from '../../redux/actions';
import Heading from '../Heading';
import NavButtons from '../NavButtons';
import { splitName } from '../../utils';

class AuthorizedAgent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      states: [],
    };
  }

  componentWillMount() {
    const usStates = new UsaStates();
    let { states } = usStates;
    states = [{ abbreviation: 'Non-U.S.' }, ...states];
    this.setState({ states });
  }

  handleCheck(e, value) {
    const authorizedChecked = e.target.checked ? true : false;

    let authorizedAgent = {};
    if (authorizedChecked) {
      const { profile } = this.props;
      const names = splitName(profile.name);

      authorizedAgent = {
        firstName: names.firstName || '',
        lastName: names.lastName || '',
        email: profile.email || '',
        address: profile.address || '',
        city: profile.city || '',
        state: profile.state || '',
        zip: profile.postal || '',
        country: profile.country || '',
        tel: profile.tel || '',
      };
    } else {
      authorizedAgent = {
        firstName: '',
        lastName: '',
        email: '',
        address: '',
        city: '',
        state: '',
        zip: '',
        country: '',
        tel: '',
      };
    }

    this.props.assignAttribute('authorizedAgent', { ...authorizedAgent });
    this.props.assignAttribute('authorizedChecked', authorizedChecked);
  }

  handleText(e, key) {
    const { fields } = this.props;
    const authorizedAgent = fields.authorizedAgent || {};

    authorizedAgent[key] = e.target.value;
    this.props.assignAttribute('authorizedAgent', { ...authorizedAgent });
  }

  handleNext() {
    const { fields } = this.props;
    const authorizedAgent = fields.authorizedAgent || {};

    this.props.hideAlert();

    const keys = [
      'firstName',
      'address',
      'city',
      'state',
      'zip',
      'country',
      'email',
    ];
    const checked = keys.every((key) => authorizedAgent[key]);

    if (!checked) {
      this.props.alert('error', 'Please check the required fields.');
    } else {
      this.props.router.push('/copyright-reg/certificate-recipient');
    }
  }

  handlePrev() {
    this.props.router.goBack();
  }

  render() {
    const { fields } = this.props;
    const { states } = this.state;
    const authorizedAgent = fields.authorizedAgent || {};

    return (
      <div className="authorized-agent">
        <Heading text="Who will be the primary contact for your registration?" />
        <div className="content">
          <p>
            <span className="text-red">*</span>
            <b>Authorized Agent</b>
          </p>
          <p>
            Designate an authorized agent to be contacted for permission to use
            this work
          </p>
          <Form>
            <FormGroup>
              <Checkbox
                checked={
                  fields.authorizedChecked ? fields.authorizedChecked : false
                }
                onChange={(e) => this.handleCheck(e)}
              >
                List me as the authorized agent
              </Checkbox>
            </FormGroup>
            <div className="inner">
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>First Name:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={authorizedAgent.firstName || ''}
                  onChange={(e) => this.handleText(e, 'firstName')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">Middle Name: </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={authorizedAgent.middleName || ''}
                  onChange={(e) => this.handleText(e, 'middleName')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>Last Name:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={authorizedAgent.lastName || ''}
                  onChange={(e) => this.handleText(e, 'lastName')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">Organization: </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={authorizedAgent.organization || ''}
                  onChange={(e) => this.handleText(e, 'organization')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>Address:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={authorizedAgent.address || ''}
                  onChange={(e) => this.handleText(e, 'address')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>City:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={authorizedAgent.city || ''}
                  onChange={(e) => this.handleText(e, 'city')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>State:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  componentClass="select"
                  className="inline"
                  value={authorizedAgent.state || -1}
                  onChange={(e) => this.handleText(e, 'state')}
                >
                  <option disabled key={-1} value={-1}>
                    Select State
                  </option>
                  {states.map((item, i) => (
                    <option key={i} value={item.abbreviation}>
                      {item.abbreviation}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>Zip/Postal:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={authorizedAgent.zip || ''}
                  onChange={(e) => this.handleText(e, 'zip')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>Country:{' '}
                </ControlLabel>
                <FormControl
                  type="text"
                  componentClass="select"
                  className="inline"
                  value={authorizedAgent.country || -1}
                  onChange={(e) => this.handleText(e, 'country')}
                >
                  <option disabled key={-1} value={-1}>
                    Select Country
                  </option>
                  {countries.map((country, i) => (
                    <option key={i} value={country.country}>
                      {country.country}
                    </option>
                  ))}
                </FormControl>
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">Tel: </ControlLabel>
                <FormControl
                  type="text"
                  className="inline"
                  value={authorizedAgent.tel || ''}
                  onChange={(e) => this.handleText(e, 'tel')}
                />
              </FormGroup>
              <FormGroup>
                <ControlLabel className="w-110px">
                  <span className="text-red">*</span>Email:{' '}
                </ControlLabel>
                <FormControl
                  type="email"
                  className="inline"
                  value={authorizedAgent.email || ''}
                  onChange={(e) => this.handleText(e, 'email')}
                />
              </FormGroup>
            </div>
          </Form>
        </div>
        <br />

        <div className="step-nav">
          <NavButtons direction="back" prev={() => this.handlePrev()} />
          <NavButtons direction="next" next={() => this.handleNext()} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  fields: state.coreg.fields,
  profile: state.profile,
});

const mapDispatchToProps = (dispatch) => ({
  alert: (type, msg) => {
    dispatch(actions.alert(type, msg));
  },
  hideAlert: () => {
    dispatch(actions.hideAlert());
  },
  assignAttribute: (field, attribute) => {
    dispatch(actions.assignCoregAttribute(field, attribute));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AuthorizedAgent);



// WEBPACK FOOTER //
// src/components/Copyright/AuthorizedAgent.jsx